import { ENTITY_PROFILE_HEADER_EDITABLE_AVATAR_MENU_ACTION } from './EntityProfileHeaderEditableAvatar.constants'

export function isEntityProfileHeaderEditableAvatarMenuActionEdit(action) {
  return action === ENTITY_PROFILE_HEADER_EDITABLE_AVATAR_MENU_ACTION.EDIT
}

export function getEntityProfileHeaderEditableAvatarMenuOptions(t) {
  return [
    {
      label: t('UploadImage.EditPhotoMenuKey'),
      value: ENTITY_PROFILE_HEADER_EDITABLE_AVATAR_MENU_ACTION.EDIT,
    },
    {
      label: t('UploadImage.DeletePhotoMenuKey'),
      value: ENTITY_PROFILE_HEADER_EDITABLE_AVATAR_MENU_ACTION.DELETE,
    },
  ]
}
